import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers'; // This is your combined reducer from reducers/index.js

// --- Step 1: Create a function to load the state from localStorage ---
const loadState = () => {
  try {
    const serializedState = localStorage.getItem('userSession');
    if (serializedState === null) {
      return undefined; // If no state, return undefined to let reducers handle initial state
    }
    const user = JSON.parse(serializedState);
    
    // IMPORTANT: The shape of this object must match your Redux state structure.
    // We are assuming your authentication slice is named 'auth' inside your rootReducer.
    // If you named it something else (e.g., 'user'), change 'auth' to that name.
    return { 
      auth: { 
        user: user, 
        isLoggedIn: true, 
        error: null 
      } 
    };
  } catch (err) {
    console.error("Could not load state from localStorage", err);
    return undefined;
  }
};

// --- Step 2: Call the function to get the preloaded state ---
const preloadedState = loadState();

// --- Step 3: Configure the store and pass in the preloadedState ---
const store = configureStore({
  reducer: rootReducer,
  preloadedState: preloadedState, // This will initialize the store with the persisted state
});

// --- Step 4 (Recommended): Listen for store changes and save to localStorage ---
store.subscribe(() => {
  try {
    const state = store.getState();
    // We only want to save the user object part of the auth state
    const userSession = state.auth.user;

    if (userSession) {
      localStorage.setItem('userSession', JSON.stringify(userSession));
    } else {
      // If the user logs out (user becomes null), remove it from localStorage
      localStorage.removeItem('userSession');
    }
  } catch (err) {
    console.error("Could not save state to localStorage", err);
  }
});

export default store;